import { render } from "./DccOption.vue?vue&type=template&id=621bb8ad"
import script from "./DccOption.vue?vue&type=script&lang=js"
export * from "./DccOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__